export const MERCHANT_GROUP_FORM_FIELDS = [
    {
        name: 'merchantGroupId',
        label: 'Merchant Group ID',
        type: 'text',
        placeholder: 'Enter merchant group ID',
        required: true,
        validationMessage: 'Please provide a merchant group ID.',
    },
    {
        name: 'groupName',
        label: 'Group Name',
        type: 'text',
        placeholder: 'Enter merchant group name',
        required: false,
        validationMessage: 'Please provide a group name.',
    },
    {
        name: 'description',
        label: 'Description',
        type: 'textarea',
        placeholder: 'Enter group description',
        required: false,
        validationMessage: 'Please provide a description.',
        rows: 3,
    },
    {
        name: 'imageUrl',
        label: 'Image URL',
        type: 'text',
        placeholder: 'Enter group image URL',
        required: false,
        validationMessage: 'Please provide an image URL.',
    },
]